import { RefObject, useEffect } from 'react';

const clickIsOutside = (refs: Array<RefObject<Element>>, clickedNode: Node) => {
    return refs.every((ref) => {
        return ref.current && !ref.current.contains(clickedNode);
    });
};

const useOnClickOutside = (
    ref: RefObject<HTMLElement>,
    handler: () => void,
    excludes?: Array<RefObject<HTMLElement>>
) => {
    const listener = (event: Event) => {
        if (!clickIsOutside([ref, ...(excludes ?? [])], event.target as Node)) {
            return;
        }

        handler();
    };

    useEffect(() => {
        document.addEventListener('mousedown', listener);
        document.addEventListener('touchstart', listener);

        return () => {
            document.removeEventListener('mousedown', listener);
            document.removeEventListener('touchstart', listener);
        };
    }, [ref, handler]);
};

export default useOnClickOutside;
